const _ = require('lodash')
import Vue from 'vue'

let messages = []
let savedMessages = JSON.parse(localStorage.getItem('messages'))
if (savedMessages) messages = savedMessages

let readMessages = []
let savedRead = JSON.parse(localStorage.getItem('read_messages'))
if (savedRead) readMessages = savedRead

let readInPageMessageIds = JSON.parse(localStorage.getItem('read_in_page_message_ids')) || []

const state = {
    messages: messages,
    messagesRead: readMessages,
    readInPageMessageIds
}

const getters = {
    messages: state => state.messages,
    messagesRead: state => state.messagesRead,
    unreadMessagesCount: state => {
        let unread = 0

        state.messages.forEach(message => {
            if (state.messagesRead.indexOf(message.id) === -1) unread++
        })

        return unread
    },
    inPageMessages: (state, getters) => _.filter(state.messages, message => message.in_page),
    unreadInPageMessages: (state, getters) => _.filter(getters.inPageMessages, message => !_.includes(state.readInPageMessageIds, message.id)),
    lastUnreadInPageMessage: (state, getters) => _.first(getters.unreadInPageMessages)

}

const mutations = {
    setMessagesRead: (state, messagesRead) => {
        state.messagesRead = messagesRead
    },

    setMessages: (state, messages) => {
        state.messages = messages
    },

    addNewMessage: (state, message) => {
        const idx = _.findIndex(state.messages, { id: message.id })
        if(idx !== -1) {
          Vue.set(state.messages, idx, message)
        } else {
          state.messages.unshift(message)
        }
        localStorage.setItem('messages', JSON.stringify(state.messages))
    },

    removeMessage: (state, message) => {
        state.messages = state.messages.filter(msg => {
            return msg.id != message.id
        })
        localStorage.setItem('messages', JSON.stringify(state.messages))
    },

    setReadInPageMessageIds: (state, messageIds) => {
        state.readInPageMessageIds = messageIds
        localStorage.setItem('read_in_page_message_ids', JSON.stringify(messageIds))
    }
}

const actions = {
    fetchMessages: ({ commit, dispatch }) => {
        axios.get('/messages')
                .then(response => {
                    let messages = response.data
                    messages.sort((a, b) => {
                        return a.created_at < b.created_at ? 1 : -1
                    })
                    commit('setMessages', messages)
                    localStorage.setItem('messages', JSON.stringify(messages))
                })
    },

    saveReadMessages: ({ commit, state }) => {
        let read = []

        for (var i = 0; i < state.messages.length; i++) {
            read.push(state.messages[i].id)
        }

        commit('setMessagesRead', read)

        localStorage.setItem('read_messages', JSON.stringify(read))
    },

    addReadInPageMessage({ commit, state }, readInPageMessage) {
      const { id } = readInPageMessage
      const newReadInPageMessageIds = _.union(state.readInPageMessageIds, [id])
      commit('setReadInPageMessageIds', newReadInPageMessageIds)
      const newReadMessageIds = _.union(state.messagesRead, [id])
      commit('setMessagesRead', newReadMessageIds)
      localStorage.setItem('read_messages', JSON.stringify(newReadMessageIds))
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
